import { IonContent, Platform } from '@ionic/angular';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { AddressService } from 'src/app/services/address/address.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { birthdayValidator, coutryPostalMatchValidator, POboxValidator, POboxValidatorGroup, mustBeTruthy, NAME_PATTERN, noWhitespaceOnlyValidator, SCREENNAME_PATTERN, streetValidator } from 'src/app/services/customFormValidators';
import { isUndefined } from 'src/app/services/codeUtils';
import { CustomerModel } from 'src/app/models/customer-model';
import { CommonAlertService } from 'src/app/services/alert/alert.service';

@Component({
  selector: 'app-signup-step-two',
  templateUrl: './signup-step-two.component.html',
  styleUrls: ['./signup-step-two.component.scss'],
})

export class SignupStepTwoComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() pageParams: any
  @Input() wrongPhone: boolean;

  public infoForm: FormGroup;
  public salutation: AbstractControl;
  public firstName: AbstractControl;
  public lastName: AbstractControl;
  public middleName: AbstractControl;
  public streetGroup: AbstractControl;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public autosearch: AbstractControl;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public country: AbstractControl;
  public postalCode: AbstractControl;
  public province: AbstractControl;
  public phoneNumber: AbstractControl;
  public securityQuestion: AbstractControl;
  public secondSecurityQuestion: AbstractControl;
  public securityAnswer: AbstractControl;
  public secondSecurityAnswer: AbstractControl;
  public certOver18: AbstractControl;
  public ackRegulationsOtherOption: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;
  public genderPrefix: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public ackRegulationsName: string;
  public ackRegulationsOtherOptionName: string;
  public ackRegulationsPAOption: string;
  public addresses = [];
  public bonusCode: any;
  public buttonDisabled: boolean = false;
  public csrf_token: string;
  public customer: CustomerModel;
  public customerWillLogout: boolean = false;
  public environmentName: string;
  public error = null;
  public featureSiteTermsLink: string;
  public legalAge: number;
  public migrated: boolean = false;
  public offer: any;
  public promoCode: string;
  public provinces: any[];
  public refreshedCustomer: boolean = false;
  public responsibleGamingNumber: string;
  public selectedCountry: string;
  public selectedCountryCode: string = 'CAN';
  public showAddressResults = false;
  public showAddressFields = false;
  public secondSecurityQuestions: any[];
  public securityQuestions: any[];
  public welcomePackageImgUrl: string;

  public aliasNameCheck: boolean;
  public citizenshipCheck: boolean;
  public jobIndustryCheck: boolean;
  public employerNameCheck: boolean;
  public employerAddressCheck: boolean;
  public businessPhoneCheck: boolean;

  public aliasName: AbstractControl;
  public employerName: AbstractControl;
  public employerAddress: AbstractControl;
  public businessPhoneNumber: AbstractControl;
  public citizenship: AbstractControl;
  public descriptiveOccupation: AbstractControl;
  public jobTitle: AbstractControl;
  public industry: AbstractControl;
  public ackRegulationsCan1: AbstractControl;
  public ackRegulationsCan2: AbstractControl;
  public ackRegulationsCan3: AbstractControl;
  public ackRegulationsCan4: AbstractControl;
  public ackRegulationsCan5: AbstractControl;
  public ackRegulationsCan6: AbstractControl;
  public ackRegulationsCan7: AbstractControl;
  public strongAuthentification: AbstractControl;
  public isMFAFirst: boolean = false;
  public wrongPhoneNumber: boolean;

  public countries: any[];
  public citizenships: any[];
  public selectedCountryCitizenship: string;

  public jobTitleList: any[];
  public jobTitleListObservable: Observable<string[]>;
  public holdJobTitleResponse: any[];
  public searchJob: string = '';
  public showJobTitleResults: boolean = false;

  public jobIndustryList: any[];
  public jobIndustryListObservable: Observable<string[]>;
  public holdJobIndustryResponse: any[];
  public searchIndustry: string = '';
  public showJobIndustryResults = false;
  public isMfaEnabled: boolean = false;
  public isSecurityQuestionsOn: boolean = false;
  public streetRegExpOn: boolean = false;

  public csrf = new FormControl('');

  public addressElProps = {
    inputStyle: 'none',
    label: 'or enter address manually',
    textAlign: 'left',
  };

  public stateName: string;
  public middleNameOnStepTwo: boolean;
  public salutationOnStepTwo: boolean;
  public phoneNumberStepTwo: boolean;
  public ackRegulationsCan7OnStepTwo: boolean;
  public ackRegulationsCan6OnStepTwo: boolean;
  public ackRegulationsCan1OnStepTwo: any;
  public certOver18OnStepTwo: any;
  public ack2AndAck3Combined: boolean;
  public pepValue: any;
  public onFooterText: any;
  public showPepError: boolean = false;

  constructor(
    private addressService: AddressService,
    private appLinksService: AppLinksService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private globalErrorHandler: GlobalErrorHandlerService,
    private logoutService: LogoutService,
    private navigator: Navigator,
    private platform: Platform,
    private userSessionService: UserSessionService,
    private commonAlertService: CommonAlertService,
    private successMessageService: SuccessMessageService,
  ) {
  }

  ngOnInit(): void {

    if (!!this.pageParams) {
      this.migrated = this.pageParams.migrated;
      this.bonusCode = this.pageParams.bonusCode;
    }


    const config = this.configService?.getConfig();

    this.stateName = config?.FEATURE_STATE_NAME?.toUpperCase() ?? "ONTARIO";
    this.selectedCountry = config?.FEATURE_SITE_COUNTRY_REGION.toUpperCase() ?? 'CANADA';
    this.aliasNameCheck = config?.FEATURE_SIGNUP_SHOW_ALIAS_FIELD === '1' ? true : false;
    this.citizenshipCheck = config?.FEATURE_SIGNUP_SHOW_CITIZEN_FIELD === '1' ? true : false;
    this.jobIndustryCheck = config?.FEATURE_SIGNUP_SHOW_JOB_INDUSTRY_FIELD === '1' ? true : false;
    this.employerNameCheck = config?.FEATURE_SIGNUP_SHOW_EMPLOYER_NAME_FIELD === '1' ? true : false;
    this.employerAddressCheck = config?.FEATURE_SIGNUP_SHOW_EMPLOYER_ADDRESS_FIELD === '1' ? true : false;
    this.businessPhoneCheck = config?.FEATURE_SIGNUP_SHOW_BUSINESS_PHONE_FIELD === '1' ? true : false;
    this.phoneNumberStepTwo = config?.FEATURE_PHONE_STEP_TWO === '1' ? true : false;
    this.legalAge = config?.FEATURE_LEGAL_AGE ?? 21;
    this.ackRegulationsName = config?.SIGNUP_ACKNOWLEDGMENT_1 ?? "I certify that all the information I provide during account creation is true and accurate";
    this.ackRegulationsOtherOptionName = config?.SIGNUP_ACKNOWLEDGMENT_3 ?? "I understand that I am prohibited from allowing any other person to access or use this gaming account.";
    this.isSecurityQuestionsOn = config?.FEATURE_MFA_ON_EMAIL === '1' ? false : true;
    this.streetRegExpOn = config?.FEATURE_STREET_REGEX_ON === '1' ? true : false;
    this.middleNameOnStepTwo = config?.FEATURE_MIDDLE_NAME_STEP_TWO === '1' ? true : false;
    this.salutationOnStepTwo = config?.FEATURE_SALUTATION_STEP_TWO === '1' ? true : false;
    this.ackRegulationsCan1OnStepTwo = config?.FEATURE_ACK1_STEP_TWO === '1' ? true : false;
    this.ackRegulationsCan6OnStepTwo = config?.FEATURE_ACK6_STEP_TWO === '1' ? true : false;
    this.ackRegulationsCan7OnStepTwo = config?.FEATURE_ACK7_STEP_TWO === '1' ? true : false;
    this.certOver18OnStepTwo = config?.FEATURE_CERT_OVER_STEP_TWO === '1' ? true : false;
    this.ack2AndAck3Combined = config?.FEATURE_ACK2_ACK3_COMBINED_STEP_TWO === '1' ? true : false;
    this.onFooterText = config?.FEATURE_ON_STEP_TWO_FOOTER_TEXT ?? '';

    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      csrf: this.csrf,
      salutation: new FormControl(''),
      autosearch: new FormControl(''),
      firstName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      middleName: new FormControl('', [Validators.pattern(NAME_PATTERN)]),
      aliasName: new FormControl(({ value: "", disabled: !this.aliasNameCheck }), [Validators.pattern(SCREENNAME_PATTERN)]),
      streetGroup: new FormGroup(
        {
          street: new FormControl('', [Validators.required, this.streetRegExpOn ? streetValidator : POboxValidator]),
          street2: new FormControl('', [POboxValidator]),
        }, POboxValidatorGroup
      ),
      city: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      countryInfoGroup: new FormGroup(
        {
          country: new FormControl({ value: '', disabled: true }, [Validators.required]),
          postalCode: new FormControl('', [Validators.required]),
        },
        coutryPostalMatchValidator
      ),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
      province: new FormControl('', [Validators.required]),
      customerAttributionData: new FormControl(''),
      extAffiliateId: new FormControl(''),

      citizenship: new FormControl(({ value: "CA", disabled: !this.citizenshipCheck }), [Validators.required, Validators.pattern(NAME_PATTERN)]),
      descriptiveOccupation: new FormGroup({
        jobTitle: new FormControl(({ value: "", disabled: !this.jobIndustryCheck }), [Validators.required]),
        industry: new FormControl(({ value: "", disabled: !this.jobIndustryCheck }), [Validators.required]),
      }),
      employerName: new FormControl(({ value: "", disabled: !this.employerNameCheck }), [noWhitespaceOnlyValidator, Validators.minLength(1), Validators.maxLength(100)]),
      employerAddress: new FormControl(({ value: "", disabled: !this.employerAddressCheck }), [noWhitespaceOnlyValidator, Validators.minLength(10), Validators.maxLength(255)]),
      businessPhoneNumber: new FormControl(({ value: "", disabled: !this.businessPhoneCheck }), [Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]),
      ackRegulationsCan2: new FormControl(false,[mustBeTruthy]),
      ackRegulationsCan3: new FormControl(false),
      ackRegulationsCan4: new FormControl(({ value: false, disabled: this.isMfaEnabled == true }),[mustBeTruthy]),
      ackRegulationsCan5: new FormControl(false),
      allowPromoEmails: new FormControl(false),
      allowPromoSms: new FormControl(false),
      strongAuthentification: new FormControl(false)
    });


    if (this.ackRegulationsCan1OnStepTwo) {
      this.infoForm.addControl('ackRegulationsCan1', new FormControl((false), [mustBeTruthy]
      ));
    }
    if (this.ackRegulationsCan6OnStepTwo) {
      this.infoForm.addControl('ackRegulationsCan6', new FormControl((false), [mustBeTruthy]
      ));
    }

    if (this.ackRegulationsCan7OnStepTwo) {
      this.infoForm.addControl('ackRegulationsCan7', new FormControl((false), [mustBeTruthy]
      ));
    }

    if (this.certOver18OnStepTwo) {
      this.infoForm.addControl('certOver18', new FormControl(true, [mustBeTruthy]
      ));
    }

    if (this.phoneNumberStepTwo) {
      this.infoForm.addControl('phoneNumber', new FormControl('', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]
      ));
    }

    const formgroup = this.infoForm.get('countryInfoGroup');
    formgroup.get('country').patchValue(this.selectedCountryCode);

    this.getProvinces();

    this.userSessionService.getCustomer().subscribe(customer => {
      if (customer) {
        this.customer = customer;
        if (this.customer != null) {
          this.promoCode = '';//this.customer.customData.find(data => data.key === 'promo_code').value;
        }
      }
    });

    if (this.citizenshipCheck) {
      this.citizenship = this.infoForm.get('citizenship');
    }


    if (this.citizenshipCheck) this.getCitizenshipCountries();


    if (this.jobIndustryCheck) {
      this.initializeJobsTitle();
      this.initializeJobIndustry();
    }

    this.infoForm.get('clientapp').setValue(this.configService.getClientApp());

    if (this.isSecurityQuestionsOn) {
      this.infoForm.addControl("securityQuestion", new FormControl('', [Validators.required]));
      this.infoForm.addControl("secondSecurityQuestion", new FormControl('', [Validators.required]));
      this.infoForm.addControl("securityAnswer", new FormControl('', [Validators.required, noWhitespaceOnlyValidator]));
      this.infoForm.addControl("secondSecurityAnswer", new FormControl('', [Validators.required, noWhitespaceOnlyValidator]));


      this.securityQuestion = this.infoForm.get('securityQuestion');
      this.secondSecurityQuestion = this.infoForm.get('secondSecurityQuestion');
      this.securityAnswer = this.infoForm.get('securityAnswer');
      this.secondSecurityAnswer = this.infoForm.get('secondSecurityAnswer');

    }

    if (this.salutationOnStepTwo) {
      this.salutation = this.infoForm.get('salutation');
    }

    this.firstName = this.infoForm.get('firstName');
    this.lastName = this.infoForm.get('lastName');

    if (this.middleNameOnStepTwo) {
      this.middleName = this.infoForm.get('middleName');
    }

    this.streetGroup = this.infoForm.get('streetGroup');
    this.street = this.streetGroup.get('street');
    this.street2 = this.streetGroup.get('street2');

    this.city = this.infoForm.get('city');
    this.autosearch = this.infoForm.get('autosearch');

    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

    this.countryInfoGroup = this.infoForm.get('countryInfoGroup');
    this.country = this.countryInfoGroup.get('country');
    this.postalCode = this.countryInfoGroup.get('postalCode');

    this.province = this.infoForm.get('province');

    if (this.phoneNumberStepTwo) {
      this.phoneNumber = this.infoForm.get('phoneNumber');
    }

    this.strongAuthentification = this.infoForm.get("strongAuthentification");

    this.allowPromoSms = this.infoForm.get('allowPromoSms');
    this.allowPromoEmails = this.infoForm.get('allowPromoEmails');
    this.certOver18 = this.infoForm.get('certOver18');

    if (this.aliasNameCheck) this.aliasName = this.infoForm.get('aliasName');
    if (this.citizenshipCheck) this.citizenship = this.infoForm.get("citizenship");
    if (this.jobIndustryCheck) this.descriptiveOccupation = this.infoForm.get("descriptiveOccupation");
    if (this.jobIndustryCheck) this.jobTitle = this.descriptiveOccupation.get("jobTitle");
    if (this.jobIndustryCheck) this.industry = this.descriptiveOccupation.get("industry");
    if (this.employerNameCheck) this.employerName = this.infoForm.get('employerName');
    if (this.employerAddressCheck) this.employerAddress = this.infoForm.get('employerAddress');
    if (this.businessPhoneCheck) this.businessPhoneNumber = this.infoForm.get('businessPhoneNumber');

    this.ackRegulationsCan1 = this.infoForm.get('ackRegulationsCan1');
    this.ackRegulationsCan2 = this.infoForm.get('ackRegulationsCan2');
    this.ackRegulationsCan3 = this.infoForm.get('ackRegulationsCan3');
    this.ackRegulationsCan4 = this.infoForm.get('ackRegulationsCan4');
    this.ackRegulationsCan5 = this.infoForm.get('ackRegulationsCan5');
    this.ackRegulationsCan6 = this.infoForm.get('ackRegulationsCan6');
    this.ackRegulationsCan7 = this.infoForm.get('ackRegulationsCan7');

    this.ackRegulationsCan5.setValue(false)

    const googlePlaceDebounceTime = this.configService.getConfig().FEATURE_GOOGLE_PLACE_DEBOUNCE_TIME ?? 0;
    // watch the form changing the values on autosearch field
    this.infoForm.valueChanges.pipe(
      takeUntil(this.ngUnsubscribe),
      map(form => form['autosearch']),
      distinctUntilChanged(),
      debounceTime(~~googlePlaceDebounceTime),
      switchMap(this.addressService.completeAddress)
    ).subscribe(data => {
      if (data.payload) {
        this.addresses = data.payload;
        this.showAddressResults = true;
      }
    });

    this.prePopulateFields();
    if (this.jobIndustryCheck) {
      this.jobIndustryListObservable = this.industry.valueChanges.pipe(
        startWith(''),
        map(value => this.searchJobIndustryList(value))
      );
      this.jobTitleListObservable = this.jobTitle.valueChanges.pipe(
        startWith(''),
        map(value => this.searchJobTitleList(value))
      );
    }
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.generateCsrfToken();
    this.refreshedCustomer = false;
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe((response) => {
      if (response?.payload?.token) {
        this.infoForm.controls['csrf'].setValue(response.payload.token);
        this.addressService.setCSRFToken(this.csrf_token);
      }
    });
  }

  public getProvinces() {
    this.addressService.callGetStatesByCountry(this.selectedCountryCode).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          const provs = response.payload;
          this.provinces = [];
          for (const p in provs) {
            this.provinces.push({ code: p, name: provs[p] });
          }
        }
      },
      error: error => console.error('callGetStatesByCountry ', error)
    });
  }

  private prePopulateFields() {
    if (!this.securityQuestions || !this.secondSecurityQuestions) {
      this.addressService.callGetFormMetadata().subscribe({
        next: (response: any) => {
          if (response && response?.result) {
            this.securityQuestions = response?.payload.security_questions[1];
            this.secondSecurityQuestions = response?.payload.security_questions[2];
          }
        },
        error: error => console.error('callGetFormMetadata ', error)
      });
    }

    this.authenticationService.callGetAccount().subscribe({
      next: response => {
        if (response && !!response.result) {
          const customerInfo = response.payload.customer;
          const has_strong_auth = customerInfo.customData.filter(x => { return x.key === 'CONFIRM_AUTH'; });

          if (response.result == 1) {
            if (Object.keys(customerInfo.address).length == 0) {
              this.showAddressFields = false;
              this.showAddressResults = false;
              this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
              if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');
            } else if (Object.keys(customerInfo.address).length > 0 && customerInfo.address.constructor === Object) {
              if (customerInfo.address.phoneNumber !== null) {
                this.showAddressFields = false;
                this.showAddressResults = false;
              } else {
                this.showAddressFields = true;
                this.showAddressResults = true;
              }

              this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
              if (!this.showAddressFields) this.infoForm.controls['autosearch'].setValue('');

              //birthdate format
              if (!!customerInfo.birthDate) {
                const birthDateFormattedArray = customerInfo.birthDate.split('-');
                var usersYear = Number(birthDateFormattedArray[0]);
                var usersMonth = Number(birthDateFormattedArray[1]);
                var usersDay = birthDateFormattedArray[2]; // don't make it a Number !!!
              }
              //security answers
              this.securityQuestion = customerInfo.securityQuestion;
              this.secondSecurityQuestion = customerInfo.secondSecurityQuestion;
            }

            const selectProvince = this.provinces.filter(item => {
              return item.code == customerInfo.address['state'];
            }).map(item => {
              return item.code;
            }).join('') || 'ON';

            this.wrongPhoneNumber = this.wrongPhone;

            this.infoForm.patchValue({
              salutation: customerInfo.salutation || 'Mr',
              firstName: customerInfo.firstName || '',
              lastName: customerInfo.lastName || '',
              middleName: customerInfo.middleName || '',
              aliasName: customerInfo.nickName || "",
              citizenship: customerInfo.citizenship || "",
              descriptiveOccupation:
              {
                jobTitle: customerInfo.jobTitle || "",
                industry: customerInfo.jobIndustry || "",
              },
              phoneNumber: this.wrongPhoneNumber ? '' : customerInfo.address['phoneNumber'] || '',
              securityQuestion: customerInfo.securityQuestion || '',
              securityAnswer: customerInfo.securityAnswer || '',
              secondSecurityQuestion: customerInfo.secondSecurityQuestion || '',
              secondSecurityAnswer: customerInfo.secondSecurityAnswer || '',
              city: customerInfo.address['city'] || '',
              province: selectProvince,
              allowPromoEmails: 'allowPromoEmails' in customerInfo ? customerInfo?.allowPromoEmails : false,
              allowPromoSms: 'allowPromoSms' in customerInfo ? customerInfo?.allowPromoSms : false,
              streetGroup: {
                street: customerInfo.address['street'] || '',
                street2: customerInfo.address['street2'] || '',
              },
              countryInfoGroup: {
                postalCode: customerInfo.address['postalCode'] || '',
              },
              dateOfBirthGroup: {
                dateOfBirthDay: customerInfo.birthDate ? usersDay : '',
                dateOfBirthMonth: customerInfo.birthDate ? usersMonth : '',
                dateOfBirthYear: customerInfo.birthDate ? usersYear : '',
              },
              employerName: customerInfo.employerName || "",
              employerAddress: customerInfo.employerAddress || "",
              businessPhoneNumber: customerInfo.businessPhoneNumber || "",
              ackRegulationsCan4: (has_strong_auth.length > 0 && has_strong_auth[0].value == '1') ? true : false,
              strongAuthentification:
                has_strong_auth.length > 0 && has_strong_auth[0]?.value == "1"
                  ? true
                  : false,
              // ackRegulationsCan2: 'allowPromoEmails' in customerInfo ? customerInfo.allowPromoEmails : false // allow promo emails for Canada
            });

            this.strongAuthentification?.setValue(
              has_strong_auth.length > 0 && has_strong_auth[0].value == "1"
                ? true
                : false
            );

            this.ackRegulationsCan4.setValue((has_strong_auth.length > 0 && has_strong_auth[0].value == '1') ? true : false);

          }
        }
      },
      error: error => {
        console.error(error);
      }
    });
  }

  get months() {

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (this.platform.is("capacitor")) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    const days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    const displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    const years = [];
    const min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (let i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }

  hideSearchList() {
    this.showAddressResults = false;
  }

  // google places
  fillInAddress(result) {
    this.showAddressResults = false;
    this.toggleAddress();
    this.infoForm.controls['autosearch'].setValue(result.address);
    // get the address details and set the fields with data
    this.addressService.addressDetails(result.place_id, this.csrf_token).subscribe(response => {
      const place = response.payload;
      let street = '';
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0];
        if (this.googleAddressTypes[addressType]) {
          const val = place.address_components[i][this.googleAddressTypes[addressType]];
          if (this.addressFieldsMap[addressType]) {
            const inputName = this.addressFieldsMap[addressType];
            // street = street_number + route
            if (inputName === 'street') {
              street = street + val + ' ';
              const streetGroup = <FormGroup>this.streetGroup;
              streetGroup.controls[inputName].setValue(street);
              // set postal code to countryInfoGroup
            } else if (inputName === 'postalCode') {
              const countryInfoGroup = <FormGroup>this.countryInfoGroup;
              countryInfoGroup.controls[inputName].setValue(val);
            } else {
              this.infoForm.controls[inputName].setValue(val);
            }
          }
        }
      }
    });
    return false;
  }

  toggleAddress() {
    this.showAddressFields = this.showAddressFields ? false : true;
    this.showAddressResults = this.showAddressFields ? true : false;
    this.addressElProps.label = this.showAddressFields ? 'clear, back to auto search address' : 'or enter address manually';
    if (!this.showAddressFields) {
      this.infoForm.controls['autosearch'].setValue('');
      this.street.setErrors({ incorrect: true });
      this.street2.setErrors({ incorrect: true });
      this.city.setErrors({ incorrect: true });
      this.province.setErrors({ incorrect: true });
      this.postalCode.setErrors({ incorrect: true });
    } else {
      this.street.setValue('');
      this.street2.setValue('');
      this.city.setValue('');
      this.province.setValue('');
      this.postalCode.setValue('');
    }
  }

  get googleAddressTypes() {
    return {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name',
    };
  }

  get addressFieldsMap() {
    return {
      street_number: 'street',
      route: 'street',
      locality: 'city',
      administrative_area_level_1: 'province',
      // country: 'country',
      postal_code: 'postalCode',
    };
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.infoForm.addControl('street', new FormControl(this.streetGroup.get('street').value));
    this.infoForm.addControl('street2', new FormControl(this.streetGroup.get('street2').value));

    if (this.strongAuthentification.value == true) {
      this.onSetStrongAuth();
    } else {
      this.unSetStrongAuth();
    }

    const formObj: any = this.infoForm.value;

    formObj.country = this.selectedCountryCode;

    if (this.migrated) {
      formObj.promo_code = this.pageParams.bonusCode;
    }

    this.authenticationService.callSignupStep2(formObj, this.migrated).subscribe(
      (response: any) => {
        this.globalErrorHandler.clear();
        this.buttonDisabled = false;
        if (formObj.ackRegulationsCan5 == true) {
          this.commonAlertService.showPepHioAlert(undefined, this.closeModal);
        } else {
          if (response && !!response.result) {
            if (response.result == 1) {
              const payloadObject = response.payload;
              if ((Object.keys(payloadObject).length > 0) && payloadObject.comments === "CUSTOMER_MFA_REQUIRED") {
                this.isMFAFirst = true;
                return this.doMFA(this.isMFAFirst);
              } else if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && payloadObject.hasOwnProperty('is_verified')) {
                const isVerified: boolean = response.payload.is_verified;
                const kycStep: string = response.payload.kyc_step;
                const kyc_attempts: string = response.payload.kyc_attempts;
                const kycFailErrors: any = response.payload.kyc_fail_errors;
                const idScanResult: string = response.payload.id_scan_result;
                const MFAStatus = this.userSessionService.getMFAApproval();

                if (isVerified == true && MFAStatus == "true") {
                  return this.activateCustomer();
                } else {
                  if (isVerified == true) {
                    return this.doMFA();
                  } else {
                    this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
                  }
                }

              }
            } else {
              this.infoForm.removeControl('street');
              this.infoForm.removeControl('street2');
            }
          }
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  private handleError(error) {
    this.buttonDisabled = false;
    if (this.infoForm.value.ackRegulationsCan5 == true) {
      this.commonAlertService.showPepHioAlert(undefined, this.closeModal);
    }
    this.generateCsrfToken();
    this.globalErrorHandler.setErrorCode(error.getErrorCode().toUpperCase());

    switch (error.getErrorCode().toUpperCase()) {
      case 'AGE_VERIFICATION_FAILED':
        this.globalErrorHandler.setErrorMessage('Form has errors, please see below');
        this.dateOfBirthGroup.setErrors({ 'AGE_VERIFICATION_FAILED': true })
        this.dateOfBirthGroup.markAsTouched();
        this.dateOfBirthGroup.markAsDirty();
        break;
      case 'ALREADY_HAS_ACCOUNT':
        this.globalErrorHandler.setErrorMessage('It appears this account has already been created.');
        break;
      case 'CUSTOMER_IN_BLACKLIST':
        this.globalErrorHandler.setErrorMessage('Cannot create account please contact customer support.');
        break;
      case 'GOVERNMENT_ID_ALREADY_EXISTS':
        this.globalErrorHandler.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
        break;
      case 'INVALID_BIRTHDATE':
        this.globalErrorHandler.setErrorMessage('The birthdate entered is invalid');
        break;
      case 'BAD_CONTENT':
        this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
        break;
      case 'TOKEN_INVALID':
        this.globalErrorHandler.setErrorMessage('Security checks discovered inconsistency with this form. Please try again.');
        break;
      case 'PHONE_ALREADY_EXISTS':
        this.globalErrorHandler.setErrorTitle("Sorry, the phone number cannot be used.");
        this.globalErrorHandler.setErrorMessage("Please enter an alternate number or contact Support for help");
        break;
      case 'IDNOW_RESPONSE_INVALID':
        this.globalErrorHandler.setErrorMessage("It appears this account has already been created. Please contact customer support.");
        break;
      default:
        this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
        break;

    }

    this.globalErrorHandler.setErrorMessage(error.getErrorMessage());
    this.error = error;
    this.content.scrollToTop(10);
    this.infoForm.removeControl('street');
    this.infoForm.removeControl('street2');
  }

  public verifyKYC(): any {
    const customer_id = this.authenticationService.customer.customerId;
    const government_id = this.infoForm.value.governmentId;
    const obj = {
      customer_id,
      government_id,
    }
    this.authenticationService.callVerifyKYC(obj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          const payloadObject = response.payload;
          if ((Object.keys(payloadObject).length > 0 && payloadObject.constructor === Object) && payloadObject.hasOwnProperty('is_verified')) {
            const isVerified = response.payload.is_verified;
            const kycStep = response.payload.kyc_step;
            const kyc_attempts = response.payload.kyc_attempts;
            const kycFailErrors = response.payload.kyc_fail_errors;
            const idScanResult = response.payload.id_scan_result;

            if (isVerified == true) return this.activateCustomer();
            this.startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult);
          }
        }
      },
      error: (error) => {
        console.error("ERROR", error)
        this.handleError(error);
      }
    });
  }

  startKba(kycStep, kycFailErrors, kyc_attempts, idScanResult?) {
    if (kycStep && kycStep.toUpperCase() == 'PENDING_KBA') return this.navigator.navigateTo("IdologyKbaComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_RETRY') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: false, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_SOVOS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_CS') return this.navigator.navigateTo("InvalidKycComponent", {}, { allAttemptsUsed: true, dontCallAppInitNext: true, kyc_attempts });
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult === 'pending') return this.navigator.navigateTo("CamsComponent");
    if (kycStep && kycStep.toUpperCase() == 'PENDING_IDSCAN' && idScanResult !== 'pending') return this.navigator.navigateTo("CamsComponent");
    return this.navigator.navigateTo("InvalidKycComponent", {}, { kycFailErrors: kycFailErrors, dontCallAppInitNext: true });
  }

  signUpStepTwo = () => {
    this.navigator.navigateTo("SignupStepTwoComponent", { forceModal: true }, { pageParams: this.pageParams, wrongPhone: true });
  }

  public doMFA(isMFAFirst?: boolean): any {
    const isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
    const mfa_statuses = this.configService.getConfig().FEATURE_MFA_STATUSES ?? 'ACTIVE, REAL_LOCKED, SELF_EXCLUDED_COOL_OFF, FUNDS_HELD';

    return this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
      if (this.userSessionService.getLoginResponseForMFA() && mfa_statuses.toUpperCase().includes(customer.status.toUpperCase())) {
        this.userSessionService.setMFAStatus(eMfaStatuses.required);
        if (isSMS_OR_EMAIL == 'SMS') {
          if (isMFAFirst) {
            this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.infoForm.value.governmentId, onClose: this.signUpStepTwo })
          } else {
            this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
          }
        } else {
          this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
        }
      } else {
        if (isMFAFirst) {
          this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer.customerId, isMFAFirst: this.isMFAFirst, governmentId: this.infoForm.value.governmentId, onClose: this.signUpStepTwo })
        } else {
          this.activateCustomer();
        }
      }
    });
  }

  onSetStrongAuth() {
    const confirmAuthObj = { "confirmAuth": 1 };
    this.authenticationService.callConfirmAuth(confirmAuthObj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          this.userSessionService.refreshCustomer();
        }
      },
      error: (error) => {
        error.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.globalErrorHandler.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.error = error;
        this.content.scrollToTop(10);
      }
    });
  }

  unSetStrongAuth() {
    const confirmAuthObj = { "confirmAuth": 0 };
    this.authenticationService.callConfirmAuth(confirmAuthObj).subscribe({
      next: (response) => {
        if (response.result == 1) {
          this.userSessionService.refreshCustomer();
        }
      },
      error: (error) => {
        error.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.globalErrorHandler.setErrorMessage('There was an issue trying to set strong authentication. Please contact customer support.');
        this.error = error;
        this.content.scrollToTop(10);
      }
    });
  }

  activateCustomer = () => {
    this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
  }

  closeModal = () => {
    this.navigator.dismissAll();
    this.logoutService.onLogout({ reason: 'CLOSE_SIGNUP_STEP2' });
  };

  openMatchedExternalLinks(code, title) {
    return this.appLinksService.openMatchedExternalLinksPopover(code, title)
  }

  getCitizenshipCountries() {
    this.addressService.callGetAllCountries().subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          const countriesList = response.payload;

          // Also get countries
          this.countries = [];
          this.citizenships = [];
          for (let c in countriesList) {
            if ('eligibSts' in countriesList[c]) {
              if (countriesList[c]['eligibSts'] == 'ELIGIBLE') {
                this.countries.push(countriesList[c]);
                // this.citizenships.push(countriesList[c]);
              }
            } else {
              this.countries.push(countriesList[c]);
              // this.citizenships.push(countriesList[c]);
            }

            // Push all countries for citizenship
            this.citizenships.push(countriesList[c]);
          }
          this.citizenships.sort(function (a, b) {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          })
          const indexOfCanada = this.citizenships.findIndex(({ name }) => name === 'CANADA');
          const canadaElement = this.citizenships[indexOfCanada];
          this.citizenships.splice(indexOfCanada, 1);
          this.citizenships.splice(0, 0, canadaElement);


          if (this.countries.length == 1) {
            this.selectedCountry = this.countries[0].code;
            this.country.setValue(this.countries[0].code)
          }
          // pre-selecting country of citizenship
          // if (this.citizenships.length > 0) {
          //   this.selectedCountryCitizenship = this.citizenships[0].code2;
          //   setTimeout(() => {
          //     this.citizenship.setValue(this.citizenships[0].code2);
          //   }, 200)
          // }
          this.getProvinces();
        }
      },
      error: (error) => {
        console.error("callGetStatesByCountry ", error);
      }
    })
  }

  private searchJobIndustryList(_indsutry): string[] {
    if (!!_indsutry || !isUndefined(_indsutry)) {
      const indsutryValue = _indsutry.toLowerCase();
      return this.jobIndustryList.filter(option => option.toLowerCase().includes(indsutryValue));
    } else {
      return this.jobIndustryList;
    }
  }

  private searchJobTitleList(_job): string[] {
    if (!!_job || !isUndefined(_job)) {
      const jobValue = _job.toLowerCase();
      return this.jobTitleList.filter(option => option.toLowerCase().includes(jobValue));
    } else {
      return this.jobTitleList;
    }
  }

  validateJobList() {
    const validateJob = this.jobTitleList.findIndex(item => this.searchJob.toLowerCase() === item.toLowerCase());
    if (validateJob === -1) {
      this.descriptiveOccupation.get('jobTitle').setErrors({ 'incorrect': true });
    }
  }

  validateIndustryList() {
    const validateIndustry = this.jobIndustryList.findIndex(item => this.searchIndustry.toLowerCase() === item.toLowerCase())
    if (validateIndustry === -1) {
      this.descriptiveOccupation.get('industry').setErrors({ 'incorrect': true });
    }
  }

  initializeJobsTitle() {
    this.addressService.callGetAllJobTitles().subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.holdJobTitleResponse = response.payload;
          this.jobTitleList = this.holdJobTitleResponse.map(({ id, name }) => name);
        }
      },
      error: (error) => {
        console.error("callGetAllJobTitles ", error);
      }
    })
  }

  fillInJobTitle(title) {
    this.jobTitle.setValue(title);
    this.showJobTitleResults = false;
    return false;
  }

  hideJobList() {
    this.showJobTitleResults = false;
  }

  showJobList() {
    this.showJobTitleResults = true;
  }

  initializeJobIndustry() {
    this.addressService.callGetAllJobIndustries().subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.holdJobIndustryResponse = response.payload;
          this.jobIndustryList = this.holdJobIndustryResponse.map(({ id, name }) => name);
        }
      },
      error: (error) => {
        console.error("callGetAllJobIndustries ", error);
      }
    })
  }

  fillInJobIndustry(title) {
    this.industry.setValue(title);
    this.showJobIndustryResults = false;
    return false;
  }

  hideIndustryList() {
    this.showJobIndustryResults = false;
  }

  showIndustryList() {
    this.showJobIndustryResults = true;
  }

  showPEPMessage() {
    const hoverItem = document.getElementsByClassName('pep-affirm');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('pep-affirm', 'pep-info-visible');
    }
  }

  hidePEPMessage() {
    const hoverItem = document.getElementsByClassName('pep-info-visible');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('pep-info-visible', 'pep-affirm');
    }
  }

  showFitMessage() {
    const hoverItem = document.getElementsByClassName('fit-affirm');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('fit-affirm', 'fit-info-visible');
    }
  }

  hideFitMessage() {
    const hoverItem = document.getElementsByClassName('fit-info-visible');
    for (let i = 0; i < hoverItem.length; i++) {
      hoverItem[i].className = hoverItem[i].className.replace('fit-info-visible', 'fit-affirm');
    }
  }

  validateZipCode() {
    if (this.countryInfoGroup.get('country').value) {
      if (this.countryInfoGroup.hasError('mismatch')) {
        this.countryInfoGroup.get('postalCode').setErrors({ 'incorrect': true });
      }
    }
  }

  changePep(e) {
    this.pepValue = e.target.value;
    if (this.pepValue === true) {
      this.showPepError = true;
    } else {
      this.showPepError = false;

    }
    this.ackRegulationsCan5.setValue(this.pepValue);
  }

}
